import DealSummaryItem from '../common/DealSummaryItem';
import { expandibleAreaStyles, expandibleButtonStyles, labelStyles } from '../utils/styles';
import * as constants from '../../constants';
import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as baseDealAnalyticsActionCreators from '@makemydeal/dr-dash-store/actions/baseDealAnalyticsActionCreators';

type detailsProps = {
    children: ReactNode;
    scopeId?: string;
};
const Details = ({ children, scopeId }: detailsProps) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(baseDealAnalyticsActionCreators.viewedBreakdownExpand());

        return () => {
            dispatch(baseDealAnalyticsActionCreators.viewedBreakdownCollapse());
        };
    }, []);

    return (
        <DealSummaryItem
            label={constants.DEAL_SUMMARY_DETAILS}
            value={''}
            labelStyles={labelStyles}
            expandibleButtonStyles={expandibleButtonStyles}
            expandibleAreaStyles={expandibleAreaStyles}
            scopeId={scopeId}
        >
            {children}
        </DealSummaryItem>
    );
};

export default Details;
